import LoginAuthPage from './LoginAuthPage';

export default LoginAuthPage;
